module.exports = __webpack_public_path__ + "img/eurotran.17f2b732.jpg";